import React, { FormEvent, MouseEvent, ReactNode } from 'react';
import cx from 'classnames';

import Button from 'components/button/button';

import styles from '../../auth.module.css';

/**
 * The layout of the auth pages (login, sign-up, password reset and update, account unlock) on auth.module.css.
 * Formerly the styled components of auth-styled-components.js, with the same look.
 */

type ChildrenProps = { children?: ReactNode };

export const AuthContainer = ({ children }: ChildrenProps) => <div className={styles.container}>{children}</div>;

export type AuthFormProps = ChildrenProps & {
    onSubmit?: (event: FormEvent<HTMLFormElement>) => void;
};

/** The card of a form */
export const AuthForm = ({ children, onSubmit }: AuthFormProps) => (
    <form className={styles.card} onSubmit={onSubmit}>
        {children}
    </form>
);

/** The same card without a <form>: around a form library that renders its own form */
export const AuthCard = ({ children }: ChildrenProps) => <div className={styles.card}>{children}</div>;

export type AuthHeaderProps = ChildrenProps & {
    /** no uppercase */
    ordinary?: boolean;
};

export const AuthHeader = ({ children, ordinary = false }: AuthHeaderProps) => (
    <h2 className={cx(styles.header, !ordinary && styles.headerUppercase)}>{children}</h2>
);

export const AuthText = ({ children }: ChildrenProps) => <p className={styles.text}>{children}</p>;

export const AuthError = ({ children }: ChildrenProps) => <div className={styles.error}>{children}</div>;

export type AuthSubmitButtonProps = ChildrenProps & {
    type?: 'submit' | 'button';
    disabled?: boolean;
    isLoading?: boolean;
    onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
};

/** The main button of a form, full width */
export const AuthSubmitButton = ({ children, type, disabled, isLoading, onClick }: AuthSubmitButtonProps) => (
    <Button className={styles.submitButton} type={type} disabled={disabled} isLoading={isLoading} onClick={onClick}>
        {children}
    </Button>
);

/** A field with a button inside it (show the password) */
export const AuthFieldControl = ({ children }: ChildrenProps) => <div className={styles.fieldControl}>{children}</div>;

export type AuthFieldControlButtonProps = ChildrenProps & {
    onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
};

export const AuthFieldControlButton = ({ children, onClick }: AuthFieldControlButtonProps) => (
    <Button className={styles.fieldControlButton} onClick={onClick}>
        {children}
    </Button>
);

export const AuthFieldErrorWrapper = ({ children }: ChildrenProps) => (
    <div className={styles.fieldErrorWrapper}>{children}</div>
);

export const AuthFieldError = ({ children }: ChildrenProps) => <span className={styles.fieldError}>{children}</span>;
